/**
 * FastAPI returns `detail` as a string for HTTPException but as an array of
 * objects for 422 validation errors. Rendering that array directly crashes React.
 */
export const errorMessage = (data, fallback = 'Something went wrong. Please try again.') => {
  const detail = data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const first = detail.find((d) => d?.msg);
    return first ? `Invalid request: ${first.msg}` : fallback;
  }
  if (detail && typeof detail === 'object' && typeof detail.msg === 'string') return detail.msg;
  return fallback;
};

export default errorMessage;
